export default __webpack_public_path__ + "static/media/Research_icon.ea0d96b9.gif";